<template>
  <div class="card col-12 mt-6">
    <div class="card-body text-center">
      <div class="row">
        <div class="col-12">
          <img
            src="/img/illustrations/rocket.png"
            alt="..."
            class="img-fluid mt--5 mb-4"
            style="max-width: 150px"
          />

          <h2>See how your performance stacks up against industry leaders.</h2>

          <p class="text-muted mb-1">
            Customize which Competitors are important to you and compare public review performance.
          </p>

          <a
            href="#"
            @click.prevent="
              handleMailto(
                'upgrade@ovationup.com?subject=Upgrade%20Request&body=I%20would%20like%20access%20to%20Competition.'
              )
            "
            class="btn btn-lg btn-primary mt-3"
          >
            Request Access
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
export default {
  name: 'CompetitionOffState',
  methods: {
    handleMailto(mailtoString) {
      window.parent.postMessage({ mailto: `mailto:${mailtoString}` }, Config.baseAppUrl)
    }
  }
}
</script>
